import React, { Component } from "react";
import { observer } from "mobx-react";
import { reaction } from "mobx";
import reportsStore from "../reportsStore";
import SequenceGraphComponent from "../sequence/SequenceGraphComponent";
import ReportsActivity from "../activity/ReportsActivity";

import { HEADERS } from "../constants";

@observer
class ReportsLinkedIn extends Component {
  disposeReaction = null;

  componentDidMount() {
    this.fetchData();
    
    this.disposeReaction = reaction(
        () => [reportsStore.dateFilter, reportsStore.memberIds],
        () => {
            this.fetchData();
        }
    );
  }

  componentWillUnmount() {
      if (this.disposeReaction) {
          this.disposeReaction();
      }
  }

  fetchData = () => {
    reportsStore.fetchLinkedInAnalytics();
  }

  constructGraphLinkedInData = () => {
    const {
        linkedInMessagesSent = 0,
        linkedinRepliesReceived = 0,
        linkedinConnectionRequestsSent = 0,
        linkedinConnectionRequestsAccepted = 0,
        linkedinProfileViewsCount = 0,
        profileViewsCount = 0,
        linkedinConnectionWithdrawn = 0,
        linkedinInMailsSent = 0,
        salesNavigatorImports = 0,
        salesNavigatorContactsImported = 0
    } = reportsStore.linkedInAnalyticsData || {};

    const profileViews = linkedinProfileViewsCount || profileViewsCount || 0;

    const graphData = [
      {
        header: "Connections",
        totalCount: linkedinConnectionRequestsSent + linkedinConnectionRequestsAccepted,
        dataArr: [
          {
            label: "Sent",
            value: linkedinConnectionRequestsSent ?? 0,
            color: "#3953FB"
          },
          {
            label: "Accepted",
            value: linkedinConnectionRequestsAccepted ?? 0,
            color: "#00A358"
          }
        ]
      },
      {
        header: "Messages",
        totalCount: linkedInMessagesSent + linkedinRepliesReceived,
        dataArr: [
          {
            label: "Sent",
            value: linkedInMessagesSent ?? 0,
            color: "#3953FB"
          },
          {
            label: "Replies received",
            value: linkedinRepliesReceived ?? 0,
            color: "#00A358"
          }
        ]
      },
      {
        header: "Views",
        type: "stats",
        totalCount: profileViews,
        dataArr: [
          {
            label: "Profiles viewed",
            value: profileViews ?? 0,
            color: "#67BFE5"
          }
        ]
      },
      {
        header: "SalesNavigator",
        type: "stats",
        totalCount: salesNavigatorImports + salesNavigatorContactsImported + linkedinInMailsSent,
        dataArr: [
          {
            label: "Inmails sent",
            value: linkedinInMailsSent ?? 0,
            color: "#F59064"
          },
          {
            label: "Total imports",
            value: salesNavigatorImports ?? 0,
            color: "#3953FB"
          },
          {
            label: "Contacts imported",
            value: salesNavigatorContactsImported ?? 0,
            color: "#00A358"
          }
        ]
      }
    ];
    return graphData;
  };

  render() {
    const graphData = this.constructGraphLinkedInData();
    
    const allowedHeaders = [
        "linkedInTaskCompletedCount",
        "linkedInMessagesSent",
        "linkedinRepliesReceived",
        "linkedinConnectionRequestsSent",
        "linkedinConnectionRequestsAccepted",
        "otherTaskCompletedCount"
    ];

    const extraHeaders = HEADERS.filter(h => allowedHeaders.includes(h.name)).map(header => {
        if ([
            "linkedInMessagesSent",
            "linkedinRepliesReceived",
            "linkedinConnectionRequestsSent",
            "linkedinConnectionRequestsAccepted"
        ].includes(header.name)) {
            return {
                ...header,
                displayName: header.displayName.replace("LinkedIn ", "")
            };
        }
        return header;
    });

    return (
      <div className="reportsLinkedIn">
        <SequenceGraphComponent 
          graphDataArr={graphData} 
          hideTotalCount={false} 
          customClassName="linkedInGraphsCont"
        />
        <ReportsActivity 
          allowedHeaders={allowedHeaders}
          extraHeaders={extraHeaders}
        />
      </div>
    );
  }
}

export default ReportsLinkedIn;
